import { Alert, AntdList, Avatar, Button, Divider, Form, Icons, MarkdownField, SaveButton, Select, Show, useForm } from "@pankod/refine-antd";
import { IResourceComponentsProps } from "@pankod/refine-core";
import { LabeledInvoiceImage } from "components/invoicevalidator/labeledinvoiceimage";
import { chatModel } from "interfaces";
import { useState } from "react";
import { OPENAI_LOGO_PATH, OPENAI_LOGO_PATH2 } from "scripts/site";
//const { Search } = Input;

export const InvoiceExtractorList: React.FC<IResourceComponentsProps> = () => {
  const [chatData, setChatData] = useState<chatModel[]>([]);
  const [imgUrl, setImgUrl] = useState<string>("");
  const [fieldCoordinates, setFieldCoordinates] = useState<any[]>([]);

  const handleChange = (e: string) => {
    setChatData([])

    // console.log(window.location.origin)

    setImgUrl(window.location.origin + "/invoices/" + e);

    // console.log(imgUrl)
  }

  const { formProps, saveButtonProps, formLoading } = useForm({
    onMutationSuccess(data, variables, context) {

      // Extract fields with coordinates from paragraphs
      const paragraphs = data?.data?.data[1];
      const fieldsWithCoordinates = Array.isArray(paragraphs)
        ? paragraphs.filter(p => p?.source)
        : [];

      // Store coordinates for the labeled image
      setFieldCoordinates(fieldsWithCoordinates);

      setChatData([{
        actor: "GPT-4",
        conversation: {
          contextual: String(data?.data?.data[0]),
          standard: String(data?.data?.data[0])
        },
        error: false
      }]);
    },
    onMutationError(error, variables, context) {
      setChatData([{
        actor: "GPT-4",
        conversation: {
          contextual: error?.statusCode + " - " + error?.response?.statusText + ": " + error?.response?.data?.message,
          standard: error?.statusCode + " - " + error?.response?.statusText + ": " + error?.response?.data?.message,
        },
        error: true
      }]);
    },
    redirect: false,
  });


  return (
    <Show
      canDelete={false}
      isLoading={formLoading}
      headerProps={{
        backIcon: false,
        title: "Invoice Extractor",
        extra: chatData.length > 0 && <Button danger icon={<Icons.ClearOutlined />} onClick={() => { setChatData([]) }}>Clear</Button>
      }}>
      <Alert message={
        <>Automatically extracting key information such as invoice number, date, vendor details, line items, totals, and tax information from invoices using AI can significantly streamline accounts payable processes, reduce manual data entry errors, and enhance overall operational efficiency. Learn more
        </>
      }
        type="info" showIcon={false} banner style={{ marginBottom: 20 }}></Alert>
      <Form
        {...formProps}
        layout="vertical"
        autoComplete="off"
        onFinish={(values) => {
          // Add imgUrl to form values before submission
          return formProps.onFinish?.({
            ...values,
            invoiceUrl: imgUrl
          });
        }}>

        <Form.Item
          label="Select Invoice"
          name="invoiceSelection"
          style={{ marginBottom: 40 }}
          rules={[{
            required: true,
            message: 'Please select an invoice to extract!',
          }]}
        >

          {/* <Input type="file" onChange={(e: any) => {
            handleChange(e.target.files[0].name.split(".")[0]);
          }} /> */}

          <Select
            allowClear
            placeholder="Select an Invoice"
            onChange={handleChange}
          //onChange={function (val) { setCountry(val); form.setFieldsValue({ 'location': null }) }}
          >
            <Select.Option value={"1.png"} key={"1"}>Daikin Airconditioning India Pvt. ltd.</Select.Option>
            <Select.Option value={"2.png"} key={"2"}>Jay Bajrang Traders</Select.Option>
            <Select.Option value={"3.png"} key={"3"}>GEM Govt.</Select.Option>
            <Select.Option value={"4.png"} key={"4"}>Tata Motors Ltd.</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item>
          <SaveButton {...saveButtonProps} title="Send" icon={<Icons.SendOutlined />}>Send</SaveButton>
        </Form.Item>
      </Form>

      {/* {imgUrl &&
        <img src={imgUrl} alt="Invoice" width={"100%"} height={"100%"} />
      } */}

      {imgUrl && (
        <div style={{ marginBottom: 20 }}>
          <LabeledInvoiceImage
            imgUrl={imgUrl}
            fields={fieldCoordinates}
          />
        </div>
      )}

      {chatData.length > 0 &&
        <>
          <Divider>Parsed Data</Divider>
          <div
            id="scrollableDiv"
            style={{
              maxHeight: 500,
              overflow: 'auto',
              marginBottom: 20,
              //padding: '0 16px',
              //border: '1px solid rgba(140, 140, 140, 0.35)',
            }}
          >
            <AntdList
              itemLayout="vertical"
              pagination={false}
              dataSource={chatData}
              renderItem={(item, index) => (
                <AntdList.Item style={{ border: "none" }}>
                  <AntdList.Item.Meta
                    avatar={<Avatar src={index % 2 === 0 ? OPENAI_LOGO_PATH : OPENAI_LOGO_PATH2} />}
                    title={item.actor}
                    description={
                      // <>
                      //   {
                      //     item.conversation.standard
                      //       .split(/(?:\r\n|\r|\n)/g)
                      //       .map((text, index) => <>{text}<br /></>)
                      //   }

                      // </>
                      <MarkdownField value={item?.conversation?.standard} />
                    } />
                </AntdList.Item>
              )}
            >
            </AntdList>

            {/* <MarkdownField value={chatData?.map(item => item.conversation.standard).join('\n\n')} /> */}
          </div>
        </>
      }

    </Show>
  );
};